<div class="space-y-6">
  <!-- Templates Table -->
  <app-data-table
    [data]="templates()"
    [columns]="columns"
    [rowActions]="actions"
    [isLoading]="isLoading()"
    [searchableFields]="['name', 'description']"
    addNewLabel="Vorlage hinzufügen"
    [showAddButton]="currentOrgStore.can('organization', 'createtemplate')"
    emptyStateTitle="Keine Vorlagen gefunden"
    emptyStateDescription="Erstellen Sie Vorlagen mit Berechnungsparametern und Ausrüstung."
    (addNew)="addTemplate()"
  />

  <!-- Create Template Dialog -->
  <app-create-template-dialog
    #createDialog
    [organizationId]="organizationId()"
    (templateCreated)="onTemplateCreated()"
    (templateUpdated)="onTemplateUpdated()"
  />
</div>

<!-- Templates -->
<ng-template #nameTpl let-template>
  <div class="min-w-0">
    <div class="truncate text-sm">{{ template.name }}</div>
    <div class="truncate text-xs text-muted-foreground">
      {{ getTemplateTypeLabel(template.type) }} · {{ template.calculationPeriod }} Jahre
    </div>
  </div>
</ng-template>

<ng-template #componentsTpl let-template>
  <div class="min-w-0">
      @if (template.module) {
        <div class="truncate text-sm">{{ template.module.name }}</div>
        <div class="text-xs text-muted-foreground">
          @if (template.inverters && template.inverters.length > 0) {
            {{ template.inverters.length }}× WR
          }
          @if (template.storages && template.storages.length > 0) {
            · {{ template.storages.length }}× Speicher
          }
        </div>
      } @else {
        <div class="text-muted-foreground">—</div>
      }
  </div>
</ng-template>

<ng-template #installationCostsTpl let-template>
  <div class="text-right text-sm tabular-nums">{{ getInstallationCosts(template?.id) | number: "1.2-2" }} €</div>
</ng-template>

<ng-template #materialCostsTpl let-template>
  <div class="text-right text-sm tabular-nums">{{ getMaterialCosts(template?.id) | number: "1.2-2" }} €</div>
</ng-template>

<ng-template #dateTpl let-template>
  <span class="whitespace-nowrap font-mono text-xs text-muted-foreground">{{ template?.createdAt ? (template.createdAt | date: "dd.MM.yyyy") : "—" }}</span>
</ng-template>
